import {ClinicalRecordType} from '../enum/clinical-record-type.enum';
import {FrequencyType} from '../enum/frequency-type.enum';

export interface Dosage
{
    time?: Date | string;
    amount?: number;
}

export interface Document
{
    id: string;
    name: string;
    mimeType: string;
    ocr?: string;
}

interface Frequency
{
    type?: FrequencyType;
    dosage?: Dosage[];
}

export class ClinicalRegistry
{
    public readonly id: string;

    public readonly patient: string;

    public readonly type: ClinicalRecordType;

    public readonly name: string;

    public readonly reason: string;

    public readonly chronicIllnessRelated: boolean;

    public readonly date?: Date;

    public readonly intensity?: number;

    public readonly description?: string;

    public readonly specialty?: string;

    public readonly document?: Document;

    public readonly clinician?: string;

    public readonly continuousMedication?: boolean;

    public readonly frequency?: Frequency;

    public readonly examType?: string;

    public readonly startDate?: Date;

    public readonly endDate?: Date;

    public constructor(
        id: string,
        patient: string,
        type: ClinicalRecordType,
        name: string,
        reason: string,
        chronicIllnessRelated: boolean,
        date: Date,
        intensity: number,
        description: string,
        specialty: string,
        document: Document,
        clinician: string,
        continuousMedication: boolean,
        frequency: Frequency,
        examType: string,
        startDate: Date,
        endDate: Date
    )
    {
        this.id = id;
        this.patient = patient;
        this.type = type;
        this.name = name;
        this.reason = reason;
        this.chronicIllnessRelated = chronicIllnessRelated;
        this.date = date;
        this.intensity = intensity;
        this.description = description;
        this.specialty = specialty;
        this.document = document;
        this.clinician = clinician;
        this.continuousMedication = continuousMedication;
        this.frequency = frequency;
        this.examType = examType;
        this.startDate = startDate;
        this.endDate = endDate;
    }

    public static fromJSON(clinicalRecordJSON: any): ClinicalRegistry
    {
        return new ClinicalRegistry(
            clinicalRecordJSON.id,
            clinicalRecordJSON.patient,
            clinicalRecordJSON.type,
            clinicalRecordJSON.name,
            clinicalRecordJSON.reason,
            clinicalRecordJSON.chronicIllnessRelated,
            !!clinicalRecordJSON.date ? new Date(clinicalRecordJSON.date) : clinicalRecordJSON.date,
            clinicalRecordJSON.intensity,
            clinicalRecordJSON.description,
            clinicalRecordJSON.specialty,
            clinicalRecordJSON.document,
            clinicalRecordJSON.clinician,
            clinicalRecordJSON.continuousMedication,
            clinicalRecordJSON.frequency,
            clinicalRecordJSON.examType,
            !!clinicalRecordJSON.startDate ? new Date(clinicalRecordJSON.startDate) : clinicalRecordJSON.startDate,
            !!clinicalRecordJSON.endDate ? new Date(clinicalRecordJSON.endDate) : clinicalRecordJSON.endDate
        );
    }
}
